const {splitSectionHtml} = require('./splitSectionHtml')
const {buildHtmlSection} = require('./buildHtmlSection')

function acceptAiBuilderHtml(input) {
  const source = input || {}
  if (source.pageKey === 'common') return {ok: false, reason: 'common-page'}
  if (!source.pageKey) return {ok: false, reason: 'no-page'}
  const split = splitSectionHtml(source.sourceHtml)
  if (!split.ok) return {ok: false, reason: split.reason}
  const buildSection = source.buildSection || buildHtmlSection
  return {
    ok: true,
    section: buildSection({
      html: split.html,
      css: split.css,
      js: split.js,
      heading: '',
      subheading: '',
    }),
    warnings: split.warnings,
  }
}

module.exports = {acceptAiBuilderHtml}
